import chatApi from "@/api/chatApi";
import { ChatMessageDomain, mapChatMessageDtoToDomain } from "@/types/ChatMessage";

interface ChatRepository {
    sendMessage: (message: string, chatId: string) => Promise<void>;
    getChatIdByUserId: () => Promise<string>;
    getMessages: (chatId: string, limit: number, skip: number) => Promise<ChatMessageDomain[]>;
    canUserSendMessage: () => Promise<boolean>;
    getAvailableQuestionsCount: (chatId: string) => Promise<number>;
}

const chatRepository: ChatRepository = {
    sendMessage : async (message: string, chatId: string) => {
       await chatApi.sendMessage({message: message, chatId: chatId});
    },  

    getMessages: async (chatId: string, limit: number, skip: number) => {
        const response = await chatApi.getMessages(chatId, limit, skip);
        return response.map(mapChatMessageDtoToDomain);
    },

    getChatIdByUserId: async () => {
        const response = await chatApi.getChatIdByUserId();
        return response.chatId;
    },

    canUserSendMessage: async () => {
        const response = await chatApi.canUserSendMessage();
        return response.canUserSendMessage;
    },

    getAvailableQuestionsCount: async (chatId: string) => {
        const response = await chatApi.getAvailableQuestionsCount(chatId);
        return response.unresolvedCount;
    }
}

export default chatRepository;